import type { DataTypes } from 'fitify-ui-landing/src/@types'

export interface CtaButton {
  title: string
  url: string
}

export interface FeatureItem extends DataTypes.FeatureItem {
  ctaButton?: CtaButton
}

export const businessFeaturesData: FeatureItem[] = [
  {
    title: 'cl_landing_highlight_1_headline',
    content: 'cl_landing_highlight_1_text',
    image: '/assets/images/features/{{language}}/img1@2x.webp',
    imageSet:
      '/assets/images/features/{{language}}/img1.webp 600w, /assets/images/features/{{language}}/img1@2x.webp 2x, /assets/images/features/{{language}}/img1@2x.webp 1200w',
    ctaButton: {
      title: 'cl_landing_highlight_1_cta',
      url: '/nutria-science',
    },
  },
  {
    title: 'cl_landing_highlight_2_headline',
    content: 'cl_landing_highlight_2_text',
    image: '/assets/images/features/{{language}}/img2@2x.webp',
    imageSet:
      '/assets/images/features/{{language}}/img2.webp 600w, /assets/images/features/{{language}}/img2@2x.webp 2x, /assets/images/features/{{language}}/img2@2x.webp 1200w',
  },
  {
    title: 'cl_landing_highlight_3_headline',
    content: 'cl_landing_highlight_3_text',
    image: '/assets/images/features/{{language}}/img3@2x.webp',
    imageSet:
      '/assets/images/features/{{language}}/img3.webp 600w, /assets/images/features/{{language}}/img3@2x.webp 2x, /assets/images/features/{{language}}/img3@2x.webp 1200w',
    ctaButton: {
      title: 'cl_landing_highlight_3_cta',
      url: '/behavioral-science',
    },
  },
  {
    title: 'cl_landing_highlight_4_headline',
    content: 'cl_landing_highlight_4_text',
    image: '/assets/images/features/en/img4@2x.webp',
    imageSet:
      '/assets/images/features/en/img4.webp 600w, /assets/images/features/en/img4@2x.webp 2x, /assets/images/features/en/img4@2x.webp 1200w',
  },
]
